var _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileViewUpdates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.573 11.9386L17.639 11.3454C18.0015 8.08851 15.8928 5.18086 12.9291 4.85104C9.96548 4.52123 7.26913 6.89413 6.90668 10.1511L6.84066 10.7442C6.76144 11.4561 6.49225 12.1307 6.06702 12.683L5.02497 14.0365C4.07316 15.2728 4.4866 17.1432 5.83876 17.7181C9.37602 19.2221 13.2358 19.6517 17.0172 18.9621C18.4627 18.6986 19.2772 16.9648 18.6205 15.5495L17.9015 14.0001C17.6081 13.3678 17.4938 12.6505 17.573 11.9386Z",
    stroke: "#081E54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75849 18.7651C8.12465 20.2127 9.41912 21.3647 11.071 21.5486C12.7228 21.7324 14.2389 20.8932 14.9143 19.5615",
    stroke: "#081E54",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.531 8.42969L12.2656 10.815",
    stroke: "#081E54",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 3.5,
    r: 2.5,
    fill: "#A020FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileViewUpdates);
export default __webpack_public_path__ + "static/media/MobileViewUpdates.80696bf52c73538ff90402be362b441f.svg";
export { ForwardRef as ReactComponent };